/* eslint-disable react/jsx-no-literals */
import BellIcon from '@/assets/icons/bell.svg?react';
import Button from '@/components/ui/button/button.component';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover/popover.component';
import { useState } from 'react';

export const Notification = () => {
  const [openPopover, setOpenPopover] = useState(false);

  return (
    <Popover
      open={openPopover}
      onOpenChange={() => {
        setOpenPopover(!openPopover);
      }}
    >
      <PopoverTrigger aria-label="notification menu" asChild>
        <Button aria-label="notification bell icon" data-testid="notification-trigger" variant="navbar-icon">
          <BellIcon className="group-focus-visible:text-primary" />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        data-testid="notification-content"
        align="center"
        side="bottom"
        sideOffset={24}
        className="min-w-[360px] p-4"
      >
        <p className="typo-secondary text-center">
          Feature not implemented. The latest process changes and update actions will be displayed here.
        </p>
      </PopoverContent>
    </Popover>
  );
};
